/**
 * Pin positions for the REAL drone-photo map layer (percent of the day aerial
 * image, 1920x1080). Hand-placed on the actual gravel pads / buildings visible
 * in the photo (lodges confirmed from Justina's labelled photo:
 * Alpine = long lodge between the lakes, Heron & Kingfisher = the two cabins
 * by the entrance). Tent/grass spots are best-estimate on open grass — tweak
 * in Admin → Pitch Media → switch editor to "Aerial photo".
 */
export const AERIAL_PITCH_POSITIONS = {
  "daisy-hs-01": { x: 63.0, y: 49.8 },
  "daisy-hs-02": { x: 64.5, y: 47.6 },
  "daisy-hs-03": { x: 66.0, y: 45.2 },
  "daisy-hs-04": { x: 67.3, y: 42.8 },
  "daisy-hs-05": { x: 68.5, y: 40.5 },
  "daisy-hs-06": { x: 69.6, y: 38.3 },
  "daisy-hs-07": { x: 70.6, y: 36.3 },
  "daisy-hs-08": { x: 71.4, y: 34.6 },
  "daisy-hs-09": { x: 53.0, y: 35.8 },
  "daisy-hs-10": { x: 50.5, y: 36.2 },
  "walnut-hs-11": { x: 49.5, y: 34.2 },
  "walnut-hs-12": { x: 52.0, y: 34.2 },
  "walnut-hs-13": { x: 54.5, y: 34.2 },
  "walnut-hs-14": { x: 57.0, y: 34.2 },
  "walnut-hs-15": { x: 59.5, y: 34.8 },
  "walnut-grass-01": { x: 71.3, y: 33.6 },
  "walnut-grass-02": { x: 71.8, y: 33.0 },
  "walnut-grass-03": { x: 72.4, y: 32.5 },
  "walnut-grass-04": { x: 72.9, y: 31.9 },
  "walnut-grass-05": { x: 73.4, y: 31.4 },
  "walnut-grass-06": { x: 74.0, y: 30.8 },
  "walnut-grass-07": { x: 74.5, y: 30.3 },
  "walnut-grass-08": { x: 75.0, y: 29.7 },
  "walnut-grass-09": { x: 75.6, y: 29.2 },
  "walnut-grass-10": { x: 76.1, y: 28.6 },
  "walnut-grass-11": { x: 76.6, y: 28.1 },
  "walnut-grass-12": { x: 77.1, y: 27.6 },
  "walnut-tent-01": { x: 31.3, y: 32.4 },
  "walnut-tent-02": { x: 31.1, y: 31.6 },
  "walnut-tent-03": { x: 30.9, y: 30.8 },
  "walnut-tent-04": { x: 30.7, y: 30.0 },
  "walnut-tent-05": { x: 30.5, y: 29.2 },
  "walnut-tent-06": { x: 30.3, y: 28.5 },
  "walnut-tent-07": { x: 30.1, y: 27.8 },
  "walnut-tent-08": { x: 29.9, y: 27.1 },
  "walnut-tent-09": { x: 29.7, y: 26.4 },
  "walnut-tent-10": { x: 31.2, y: 27.8 },
  "walnut-tent-11": { x: 33.4, y: 28.1 },
  "walnut-tent-12": { x: 35.6, y: 28.4 },
  "walnut-tent-13": { x: 37.8, y: 28.6 },
  "walnut-tent-14": { x: 40.0, y: 28.8 },
  "walnut-tent-15": { x: 42.2, y: 29.0 },
  "walnut-tent-16": { x: 44.4, y: 29.2 },
  "walnut-tent-17": { x: 46.6, y: 29.4 },
  "walnut-tent-18": { x: 32.1, y: 33.2 },
  "walnut-tent-19": { x: 32.9, y: 34.0 },
  "walnut-tent-20": { x: 33.7, y: 34.8 },
  "lodge-alpine": { x: 46.5, y: 33.0 },
  "lodge-heron": { x: 47.5, y: 72.5 },
  "lodge-kingfisher": { x: 63.5, y: 63.0 },
};

/** Click-to-zoom zones on the aerial photo (percent boxes). */
export const AERIAL_LAKE_ZONES = {
  "Daisy Lake": { left: 30, top: 30, width: 44, height: 32, origin: "52% 46%" },
  "Walnut Lake": { left: 26, top: 20, width: 52, height: 18, origin: "52% 29%" },
};
